// A brief body, rendered from the parsed blocks in `lib/markdown.ts`.
//
// The parser produces data and this walks it, so every string goes through JSX and is escaped.
// There is no `dangerouslySetInnerHTML` in this app: a brief body is a model's output rendered
// on an authenticated page, which is exactly the shape of an injection nobody notices.

import type { MarkdownSpan } from '../lib/markdown.ts';
import { parseMarkdown } from '../lib/markdown.ts';

function Spans({ spans }: { spans: MarkdownSpan[] }) {
  return (
    <>
      {spans.map((span, index) => (
        // Index keys are correct here: spans are rebuilt wholesale from one string and are
        // never reordered or filtered in place.
        span.bold
          ? <b key={index}>{span.text}</b>
          : <span key={index}>{span.text}</span>
      ))}
    </>
  );
}

export function Markdown({ body }: { body: string }) {
  const blocks = parseMarkdown(body || '');
  if (blocks.length === 0) {
    return <p className="briefempty">This brief has no body — the facts landed without prose.</p>;
  }
  return (
    <div className="mdbody">
      {blocks.map((block, index) => {
        if (block.kind === 'heading') {
          // One visual weight for every level. The brief only writes two, and rendering h2
          // through h6 at six sizes would give the panel a hierarchy the content does not have.
          return <p key={index} className="mdhead"><Spans spans={block.spans} /></p>;
        }
        if (block.kind === 'bullet') {
          return (
            <ul key={index} className="mdlist">
              {block.items.map((item, itemIndex) => (
                <li key={itemIndex}><Spans spans={item} /></li>
              ))}
            </ul>
          );
        }
        return <p key={index} className="mdpara"><Spans spans={block.spans} /></p>;
      })}
    </div>
  );
}
